import React from "react";
import { DeliverableRow } from "..";
import styles from "./DeliverablesList.module.css";
import { isNonEmptyArray } from "../../../../../../../../../common/utils";

export default function DeliverablesList({
	deliverables,
	onAllocate,
	reqId,
	setSelectedCount,
	showSelected,
	phaseLocked = false,
}) {
	return (
		<div className={styles.container} data-phase-locked={phaseLocked}>
			{isNonEmptyArray(deliverables) &&
				deliverables.map((deliverable) => (
					<DeliverableRow
						key={deliverable.id}
						deliverable={deliverable}
						phaseLocked={phaseLocked}
						reqId={reqId}
						setSelectedCount={setSelectedCount}
						showSelected={showSelected}
						onAllocate={onAllocate}
					/>
				))}
		</div>
	);
}
